import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import VaultedPaymentMethod from '../vaultedPaymentMethod.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Callout = makeShortcode("Callout");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Get a list of `}<inlineCode parentName="p">{`VaultedPaymentMethod`}</inlineCode>{` for the `}<inlineCode parentName="p">{`customerId`}</inlineCode>{` attached to the `}<a parentName="p" {...{
        "href": "https://primer.io/docs/api/api-reference/client-session-api/create-client-side-token#request.body.customerId"
      }}>{`client session`}</a>{`.
Build your own UI to display, manage and perform payments with them.`}</p>
    <Callout variant='danger' mdxType="Callout">
      <p>{`The list of vaulted payment methods is not affected by the checkout builder's conditions.
For example, if you configured the checkout builder to not show `}<inlineCode parentName="p">{`Paypal`}</inlineCode>{` with the current client session,
but `}<inlineCode parentName="p">{`Paypal`}</inlineCode>{` was vaulted previously, `}<inlineCode parentName="p">{`fetchVaultedPaymentMethods`}</inlineCode>{` will still return it.`}</p>
      <p>{`This issue will be addressed and resolved in an upcoming release.`}</p>
    </Callout>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`// Initialise Headless Checkout ...

const vaultManager = headless.createVaultManager()
const vaultedPaymentMethods = await vaultManager.fetchVaultedPaymentMethods()
`}</code></pre>
    <p>{`Throws an error if the call to retrieve the vaulted payment methods fails.`}</p>
    <VaultedPaymentMethod mdxType="VaultedPaymentMethod" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      